// 数据映射关系表，用于将原有数据结构映射到新的公共数据结构
// 该文件定义了数据转换规则，确保组件兼容的同时实现数据集中管理

// 公共数据结构定义
export const commonDataStructure = {
  projectInfo: {
    projectName: '', // 项目名称
    calculationPeriod: 0, // 计算期
    constructionPeriod: 0, // 建设期
    operationPeriod: 0, // 运营期
    loadData: {}, // 负荷数据
    discountRate: 0, // 基准收益率
    normalYear: 0, // 正常年
  },
  investment: {
    total: 0, // 总投资
    construction: 0, // 建设投资
    interestDuringConstruction: 0, // 建设期利息
    workingCapital: 0, // 流动资金
    annual: [] // 分年投资
  },
  financing: {
    total: 0, // 资金筹措总额
    equityCapital: 0, // 项目资本金
    debtCapital: 0, // 债务资金
    // 具体债务资金类别
    debtDetails: {
      银行借款: {},
      债券: {},
      融资租赁: {},
      其他借款: {}
    },
    loans: [], // 借款数据
    interest: [] // 利息数据
  },
  // 营业收入数据
  operatingRevenue: {
    revenue: {
      revenuelist: [], // 产品列表
      revenuetotal: 0, // 收入合计
      revenueByYear: [] // 各年收入
    },
    otherinput: {
      input: 0, // 其他收入
      total: 0, // 合计
      inputByYear: [], // 各年收入
      tax: 0, // 税率
      taxTotal: 0, // 税额合计
      taxByYear: [] // 各年税额
    },
    valuededtax: [], // 可抵扣税额
    outputtax: [], // 销项税额
    inputtax: [], // 进项税额
    // 税率参数
    UMCTax: 0, // 城建税率
    Educationtax: 0, // 教育费税率
    consumptiontax: 0, // 消费税率
    additionaltax: 0, // 附加税
    // 各年合计数据
    revenuetotal: 0, // 营业收入合计
    valudedtotal: 0, // 增值税合计
    outputtotal: 0, // 销项税合计
    inptotal: 0, // 进项税合计
    // 各年明细数据
    revenueByYear: [],
    valueddedtax: [],
    outputtaxByYear: [],
    inputtaxByYear: [],
    additionaltaxByYear: [],
    consumptiontaxByYear: [],
    UMCTaxByYear: [],
    EducationtaxByYear: []
  },
  // 成本费用数据
  costExpenses: {
    fuelPower: {
      // 燃料动力费数据
    },
    welfare: {
      // 工资福利数据
    },
    depreciation: {
      // 折旧费数据
    },
    amortization: {
      // 摊销费数据
    },
    workingCapital: {
      // 流动资金数据
    },
    totalCost: {
      // 总成本费用数据
    }
  },
  // 盈利能力分析数据
  profitabilityAnalysis: {},
  // 盈亏平衡分析数据
  breakevenAnalysis: {},
  normalYearIndicators: {} // 正常年指标
};

// 数据映射规则
export const dataMappingRules = {
  // 从原有数据到公共数据的映射
  toCommonData: {
    // 基础数据映射
    'projectInfo.projectName': ['projectName', 'jindexname'],
    'projectInfo.calculationPeriod': ['基础数据.calculationPeriod'],
    'projectInfo.constructionPeriod': ['基础数据.constructionPeriod'],
    'projectInfo.operationPeriod': ['基础数据.operationPeriod'],
    'projectInfo.loadData': ['基础数据.loadData'],
    'projectInfo.discountRate': ['基础数据.discountRate'],
    'projectInfo.normalYear': ['基础数据.normalYear'],
    
    // 总投资映射
    'investment.total': ['总投资估算.总表.总投资.合计'],
    'investment.construction': ['总投资估算.总表.建设投资.合计'],
    'investment.interestDuringConstruction': ['总投资估算.总表.建设期利息.合计'],
    'investment.workingCapital': ['总投资估算.总表.流动资金.合计'],
    
    // 资金筹措映射
    'financing.total': ['资金筹措及分年投资计划.资金筹措.amount'], 
     'financing.equityCapital': ['资金筹措及分年投资计划.资金筹措.项目资本金.amount'], 
     'financing.debtCapital': ['资金筹措及分年投资计划.资金筹措.债务资金.amount'], 
     
     // 具体债务资金类别映射 
     'financing.debtDetails': ['资金筹措及分年投资计划.资金筹措.债务资金'], 
     'financing.debtDetails.银行借款': ['资金筹措及分年投资计划.资金筹措.债务资金.银行借款'], 
     'financing.debtDetails.债券': ['资金筹措及分年投资计划.资金筹措.债务资金.债券'], 
     'financing.debtDetails.融资租赁': ['资金筹措及分年投资计划.资金筹措.债务资金.融资租赁'], 
     'financing.debtDetails.其他借款': ['资金筹措及分年投资计划.资金筹措.债务资金.其他借款'], 
     
     // 营业收入数据映射 
     'operatingRevenue.revenue': ['营业收入税金及利润.营业收入及营业税金.revenue'], 
     'operatingRevenue.otherinput': ['营业收入税金及利润.营业收入及营业税金.otherinput'], 
     'operatingRevenue.valudeddedtax': ['营业收入税金及利润.营业收入及营业税金.valudeddedtax'], 
     'operatingRevenue.outputtax': ['营业收入税金及利润.营业收入及营业税金.outputtax'], 
     'operatingRevenue.inputtax': ['营业收入税金及利润.营业收入及营业税金.inputtax'], 
     'operatingRevenue.UMCTax': ['营业收入税金及利润.营业收入及营业税金.UMCTax'], 
     'operatingRevenue.Educationtax': ['营业收入税金及利润.营业收入及营业税金.Educationtax'], 
     'operatingRevenue.consumptiontax': ['营业收入税金及利润.营业收入及营业税金.consumptiontax'], 
     'operatingRevenue.additionaltax': ['营业收入税金及利润.营业收入及营业税金.additionaltax'], 
     'operatingRevenue.revenuetotal': ['营业收入税金及利润.营业收入及营业税金.revenuetotal'], 
     'operatingRevenue.valudedtotal': ['营业收入税金及利润.营业收入及营业税金.valudedtotal'], 
     'operatingRevenue.outputtotal': ['营业收入税金及利润.营业收入及营业税金.outputtotal'], 
     'operatingRevenue.inptotal': ['营业收入税金及利润.营业收入及营业税金.inptotal'], 
     'operatingRevenue.revenueByYear': ['营业收入税金及利润.营业收入及营业税金.revenueByYear'], 
     'operatingRevenue.valueddedtax': ['营业收入税金及利润.营业收入及营业税金.valueddedtax'], 
     'operatingRevenue.outputtaxByYear': ['营业收入税金及利润.营业收入及营业税金.outputtaxByYear'], 
     'operatingRevenue.inputtaxByYear': ['营业收入税金及利润.营业收入及营业税金.inputtaxByYear'], 
     'operatingRevenue.additionaltaxByYear': ['营业收入税金及利润.营业收入及营业税金.additionaltaxByYear'], 
     'operatingRevenue.consumptiontaxByYear': ['营业收入税金及利润.营业收入及营业税金.consumptiontaxByYear'], 
     'operatingRevenue.UMCTaxByYear': ['营业收入税金及利润.营业收入及营业税金.UMCTaxByYear'], 
     'operatingRevenue.EducationtaxByYear': ['营业收入税金及利润.营业收入及营业税金.EducationtaxByYear'],
    
    // 成本费用数据映射
    'costExpenses.fuelPower': ['成本费用.燃料动力'],
    'costExpenses.welfare': ['成本费用.职工薪酬'],
    'costExpenses.depreciation': ['成本费用.折旧费'],
    'costExpenses.amortization': ['成本费用.其他费用.摊销费'],
    'costExpenses.workingCapital': ['成本费用.流动资金'],
    'costExpenses.totalCost': ['成本费用.总成本费用'],
    
    // 盈利能力分析数据映射
    'profitabilityAnalysis': ['盈利能力分析'],
    
    // 盈亏平衡分析数据映射
    'breakevenAnalysis': ['不确定性分析']
  },
  
  // 从公共数据到原有数据的映射
  fromCommonData: {
    // 基础数据映射
    'projectName': 'projectInfo.projectName',
    'jindexname': 'projectInfo.projectName',
    '基础数据.calculationPeriod': 'projectInfo.calculationPeriod',
    '基础数据.constructionPeriod': 'projectInfo.constructionPeriod',
    '基础数据.operationPeriod': 'projectInfo.operationPeriod',
    '基础数据.loadData': 'projectInfo.loadData',
    '基础数据.discountRate': 'projectInfo.discountRate',
    '基础数据.normalYear': 'projectInfo.normalYear',
    
    // 资金筹措映射
    '资金筹措及分年投资计划.资金筹措.amount': 'financing.total',
    '资金筹措及分年投资计划.资金筹措.项目资本金.amount': 'financing.equityCapital',
    '资金筹措及分年投资计划.资金筹措.债务资金': 'financing.debtDetails',
    '资金筹措及分年投资计划.资金筹措.债务资金.amount': 'financing.debtCapital',
    
    // 具体债务资金类别映射
    '资金筹措及分年投资计划.资金筹措.债务资金.银行借款': 'financing.debtDetails.银行借款',
    '资金筹措及分年投资计划.资金筹措.债务资金.债券': 'financing.debtDetails.债券',
    '资金筹措及分年投资计划.资金筹措.债务资金.融资租赁': 'financing.debtDetails.融资租赁',
    '资金筹措及分年投资计划.资金筹措.债务资金.其他借款': 'financing.debtDetails.其他借款',
    
    // 营业收入数据映射
    '营业收入税金及利润.营业收入及营业税金.revenue': 'operatingRevenue.revenue',
    '营业收入税金及利润.营业收入及营业税金.otherinput': 'operatingRevenue.otherinput',
    '营业收入税金及利润.营业收入及营业税金.valudeddedtax': 'operatingRevenue.valudeddedtax',
    '营业收入税金及利润.营业收入及营业税金.outputtax': 'operatingRevenue.outputtax',
    '营业收入税金及利润.营业收入及营业税金.inputtax': 'operatingRevenue.inputtax',
    '营业收入税金及利润.营业收入及营业税金.UMCTax': 'operatingRevenue.UMCTax',
    '营业收入税金及利润.营业收入及营业税金.Educationtax': 'operatingRevenue.Educationtax',
    '营业收入税金及利润.营业收入及营业税金.consumptiontax': 'operatingRevenue.consumptiontax',
    '营业收入税金及利润.营业收入及营业税金.additionaltax': 'operatingRevenue.additionaltax',
    '营业收入税金及利润.营业收入及营业税金.revenuetotal': 'operatingRevenue.revenuetotal',
    '营业收入税金及利润.营业收入及营业税金.valudedtotal': 'operatingRevenue.valudedtotal',
    '营业收入税金及利润.营业收入及营业税金.outputtotal': 'operatingRevenue.outputtotal',
    '营业收入税金及利润.营业收入及营业税金.inptotal': 'operatingRevenue.inptotal',
    '营业收入税金及利润.营业收入及营业税金.revenueByYear': 'operatingRevenue.revenueByYear',
    '营业收入税金及利润.营业收入及营业税金.valueddedtax': 'operatingRevenue.valueddedtax',
    '营业收入税金及利润.营业收入及营业税金.outputtaxByYear': 'operatingRevenue.outputtaxByYear',
    '营业收入税金及利润.营业收入及营业税金.inputtaxByYear': 'operatingRevenue.inputtaxByYear',
    '营业收入税金及利润.营业收入及营业税金.additionaltaxByYear': 'operatingRevenue.additionaltaxByYear',
    '营业收入税金及利润.营业收入及营业税金.consumptiontaxByYear': 'operatingRevenue.consumptiontaxByYear',
    '营业收入税金及利润.营业收入及营业税金.UMCTaxByYear': 'operatingRevenue.UMCTaxByYear',
    '营业收入税金及利润.营业收入及营业税金.EducationtaxByYear': 'operatingRevenue.EducationtaxByYear',
    
    // 成本费用数据映射
    '成本费用.燃料动力': 'costExpenses.fuelPower',
    '成本费用.职工薪酬': 'costExpenses.welfare',
    '成本费用.折旧费': 'costExpenses.depreciation',
    '成本费用.其他费用.摊销费': 'costExpenses.amortization',
    '成本费用.流动资金': 'costExpenses.workingCapital',
    '成本费用.总成本费用': 'costExpenses.totalCost',
    
    // 盈利能力分析数据映射
    '盈利能力分析': 'profitabilityAnalysis',
    
    // 盈亏平衡分析数据映射
    '不确定性分析': 'breakevenAnalysis'
  }
};

// 数据变更触发规则，定义哪些数据变更需要触发哪些计算函数

export const dataChangeRules = {
  // 触发calculateAnnualInvestment的条件：总投资相关数据变化和正常年变化
  shouldTriggerAnnualInvestment: [
    'projectInfo.normalYear',
    'investment.total',
    'investment.construction',
    'investment.interestDuringConstruction',
    'investment.workingCapital',
    'financing.total',
    'financing.equityCapital',
    'financing.debtCapital'
  ],
  
  // 触发profitCalculation的条件：利润相关数据变化
  shouldTriggerProfitCalculation: [
    'projectInfo.normalYear',
    'projectInfo.loadData',
    'investment.total',
    'financing.total'
  ]
};

// 计算函数映射
export const calculationFunctionMapping = {
  'calculateAnnualInvestment': 'calculateAnnualInvestment',
  'profitCalculation': 'profitCalculation',
  'allInvestmentCashFlowCalculation': 'allInvestmentCashFlowCalculation',
  'capitalCashFlowCalculation': 'capitalCashFlowCalculation',
  'financialPlanCashFlowCalculation': 'financialPlanCashFlowCalculation',
  'breakevenAnalysisCalculation': 'breakevenAnalysisCalculation'
};

